import React, { Component } from 'react';

class OrderSetButton extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defaultOrderingSetNumber: this.props.defaultOrderingSetNumber,
            setNumbers: [],

            // Use this to "carry forward" set number from NewMenuItem to MenuItemModal
            extraSetNumbers: this.props.extraSetNumbers,
        }
    }
    componentDidMount() {
        this.initSetNumber()
    }

    componentDidUpdate(prevProps, prevState) {
        this.updateDefaultSetNumber(prevProps, prevState)
        this.updateSetNumberOnOrderChange(prevProps, prevState)
    }
    updateDefaultSetNumber(prevProps, prevState) {
        // User change set number causing the default value to change.
        // Most probably is change order's setNumber by moving to other set.
        // Update the selected dropdown value to match the new value
        if (prevProps.defaultOrderingSetNumber != this.props.defaultOrderingSetNumber) {
            const newSetNumber = parseInt(this.props.defaultOrderingSetNumber)
            let { setNumbers, setNumberIndex, orderingSetNumber, } = this.state

            // Since order to removed from one set into another set,
            // remove redundant set number that not used by any order
            const usedSetNumbers = this.getUsedSetNumbers(this.props.defaultOrderingSetNumber, setNumbers)

            // Use the latest setNumber list where redundant setNumber already
            // removed
            setNumbers = usedSetNumbers

            let newSetNumberIndex = setNumbers.indexOf(newSetNumber)
            if (newSetNumberIndex !== -1) {
                setNumberIndex = newSetNumberIndex
                orderingSetNumber = newSetNumber
            }

            this.setState({
                setNumbers,
                setNumberIndex,
                orderingSetNumber: newSetNumber,
            })
        }
    }
    updateSetNumberOnOrderChange = (prevProps, prevState) => {
        if (prevProps.orders !== this.props.orders) {
            this.initSetNumber()
        }
    }

    /**
     * @param {int} extraSetNumberToInclude - The unused set number to be included, possible due to user selection at user app to "add to new set"
     * @param {Array<int>} oldSetNumbers - The old set number list to validate extraSetNumberToInclude need to be included
     * @returns
     */
    getUsedSetNumbers = (extraSetNumberToInclude, oldSetNumbers) => {
        const usedSetNumbers = []
        const orders = this.props.orders || []

        const addSetNumber = (setNumber) => {
            setNumber = parseInt(setNumber || 1)
            if (usedSetNumbers.indexOf(setNumber) === -1) {
                usedSetNumbers.push(setNumber)
            }
        }

        orders.forEach(order => {
            addSetNumber(order.set_number)
        })

        if (extraSetNumberToInclude && oldSetNumbers && Array.isArray(oldSetNumbers)) {
            if (!Array.isArray(extraSetNumberToInclude)) {
                extraSetNumberToInclude = [extraSetNumberToInclude]
            }

            extraSetNumberToInclude.forEach(setNumber => {
                // Only add the extra set number if exist in previous set number array
                if (oldSetNumbers.indexOf(setNumber) !== -1) {
                    addSetNumber(setNumber)
                }
            })
        }

        // Sort properly. If orders are added and removed, the set_number
        // sequence will be affected
        usedSetNumbers.sort((a,b) => a - b)
        return usedSetNumbers
    }
    initSetNumber = () => {
        // Default "select" the first item in dropdown
        let setNumberIndex = 0
        const usedSetNumbers = this.getUsedSetNumbers()

        if (this.state.extraSetNumbers && Array.isArray(this.state.extraSetNumbers)) {
            this.state.extraSetNumbers.forEach(sn => {
                sn = parseInt(sn)
                let index = usedSetNumbers.indexOf(sn)
                if (index === -1) {
                    usedSetNumbers.push(sn)
                }
            })
        }

        let firstSetNumber = 1
        let lastOrderingSetNumber = firstSetNumber
        if (usedSetNumbers.length === 0) {
            // We do not have any order yet, prepare the first set "1"
            lastOrderingSetNumber = firstSetNumber
            usedSetNumbers.push(lastOrderingSetNumber)
        }
        else {
            // We already have existing set number. Select it
            if (lastOrderingSetNumber) {
                let index = usedSetNumbers.indexOf(this.state.defaultOrderingSetNumber || lastOrderingSetNumber)
                if (index !== -1) {
                    setNumberIndex = index
                }
                else {
                    // Set number not exist, fallback to select first set number
                    lastOrderingSetNumber = usedSetNumbers[0]
                    setNumberIndex = 0
                }
            }
        }

        this.setState({
            setNumbers: usedSetNumbers,
            setNumberIndex,
            orderingSetNumber: lastOrderingSetNumber,
        })
    }
    onSetNumberChange = (e) => {
        /**
         * On set number change
         * 1. Attempt create a new set number if user choose "New"
         *      - If has "new" set number (the last item), where this set number do not has any order yet, skip
        */
        let setNumbers = [...this.state.setNumbers]
        let orderingSetNumber = 0
        let setNumberIndex = e.target.value
        const isCreateNew = e.target.value == -1
        if (isCreateNew) {
            if (this.isAllowCreateNewSetNumber()) {
                // Add a new set number that is +1 of the last set number value
                let newSetNumber = setNumbers[setNumbers.length - 1] + 1
                orderingSetNumber = newSetNumber
                setNumbers.push(newSetNumber)
                setNumberIndex = setNumbers.length - 1  // Select the last item
            }
        }
        else {
            // Choose other existing setNumber
            orderingSetNumber = this.state.setNumbers[e.target.value]

            // Remove the last "dummy" set if not used
            if (!this.isAllowCreateNewSetNumber() && (e.target.value != this.state.setNumbers.length - 1)) {
                setNumbers.pop()
            }
        }

        this.setState({
            setNumbers,
            setNumberIndex: setNumberIndex,
            orderingSetNumber: orderingSetNumber
        })
        this.props.onSetNumberChange && this.props.onSetNumberChange(orderingSetNumber)
    }
    isAllowCreateNewSetNumber = () => {
        const lastSetNumber = [...this.state.setNumbers].pop()
        let orderOfThisLastSetNumber = (this.props.orders || []).find(order => order.set_number == lastSetNumber)
        if (!orderOfThisLastSetNumber && this.state.setNumbers.length > 1) {
            // Do not has any order using this set number, and there are still other
            // set number to choose from, no need to create
            return false
        }

        // Check if we have custom checking from parent
        if (this.props.isAllowCreateNewSetNumber) {
            return this.props.isAllowCreateNewSetNumber()
        }
        return true
    }
    getSetNumbers = () => {
        return this.state.setNumbers
    }
    getSetNumberList = () => {
        const isAllowCreateNewSetNumber = this.isAllowCreateNewSetNumber()
        let options = this.state.setNumbers.map((setNumber, index) => {
            return <option key={setNumber} value={index}>{index + 1}</option>
        })
        if (isAllowCreateNewSetNumber) {
            options.push(<option key={-1} value={-1}>New Set</option>)
        }
        return (
            <select className="form-control" onChange={this.onSetNumberChange} value={this.state.setNumberIndex}>
                {options}
            </select>
        )
    }
    render() {
        let style = this.props.style || {}
        return (
            <div style={{margin: "auto", textAlign: "center", ...style}}>
                <div style={{display: "inline-block", color: "black"}}>
                    {this.props.title || lang.add_item_to_set}
                </div>
                <div style={{display: "inline-block", marginLeft: "10px"}}>
                    {this.getSetNumberList()}
                </div>
            </div>
        )
    }
}

export default OrderSetButton;